<template>
  <div
    class="track-listing-container"
    v-bind:class="{
      'is-project-track-listing': projectId,
      'not-project-track-listing': !projectId,
    }"
    v-bind:data-project-id="projectId"
  >
    <div class="track-listing-header">
      <div class="row">
        <div
          class="col-title d-block"
          :class="{ 'col-6 col-sm-3': !isMobile, 'col-4': isMobile }"
        >
          <a
            href="#"
            class="collapse-toggle-class"
            @click.prevent="toggleSubtrackCollapse"
          >
            <i
              class="material-icons v-align-middle"
              v-if="allSubtracksExpanded === false"
              >keyboard_arrow_right</i
            >
            <i
              class="material-icons v-align-middle"
              v-if="allSubtracksExpanded === true"
              >keyboard_arrow_down</i
            >
          </a>

          <span
            class="v-align-middle track-title d-none d-md-inline"
            @click="sortbyTrack"
          >
            Track Title<small class="d-inline" v-if="sortTrack == true"
              ><i class="material-icons">keyboard_arrow_up</i></small
            ><small class="d-inline" v-if="sortTrack == false"
              ><i class="material-icons">keyboard_arrow_down</i></small
            >
          </span>
        </div>

        <div
          class="col-sm-1 col-time d-none d-md-block"
          @click="sortbyTime"
          :class="{ 'col-time-mobile': isMobile }"
        >
          Time<small class="d-inline" v-if="sortTime == true"
            ><i class="material-icons">keyboard_arrow_up</i></small
          ><small class="d-inline" v-if="sortTime == false"
            ><i class="material-icons">keyboard_arrow_down</i></small
          >
        </div>

        <div
          v-bind:class="waveformVisible ? 'col-sm-3' : 'col-sm-5'"
          class="col-desc d-none d-md-block"
          v-if="!isMobile"
        >
          Description
        </div>

        <div
          class="col-album d-none d-md-block"
          @click="sortbyAlbum"
          :class="{ 'col-sm-2': !isMobile, 'col-sm-3': isMobile }"
        >
          Album<small class="d-inline" v-if="sortAlbum == true"
            ><i class="material-icons">keyboard_arrow_up</i></small
          ><small class="d-inline" v-if="sortAlbum == false"
            ><i class="material-icons">keyboard_arrow_down</i></small
          >
        </div>

        <div
          v-bind:class="{
            'col-sm-3': waveformVisible,
            'col-sm-1': !waveformVisible,
            'col-toggle-waveform-mobile': isMobile,
          }"
          class="col-6 col-toggle-waveform text-right d-none d-md-inline"
        >
          <div class="float-left header-icon">
            <i class="material-icons invisible">cloud_download</i>
            <i class="material-icons invisible">cloud_download</i>
            <a
              href="#"
              @click.prevent="downloadSharedProject"
              title="Download Tracks"
              v-if="downloadAll"
            >
              <i class="material-icons">cloud_download</i>
            </a>

            <a
              href="#"
              class="no-download-all"
              @click.prevent="disabledDownloadAll"
              v-if="!downloadAll && resourceType == 'project'"
            >
              <i class="material-icons text-stardust-grey">cloud_download</i>
            </a>
          </div>

          <a
            href="#"
            @click.prevent="toggleWaveform"
            class="float-right font-weight-semibold"
          >
            <span v-if="waveformVisible">Hide Waveform</span>
            <span v-if="!waveformVisible">Show Waveform</span>
          </a>
        </div>
      </div>
    </div>

    <div
      class="track-list-accordion"
      role="tablist"
      v-bind:id="'trackListAccordion' + _uid"
      v-bind:ref="'scrollContainer' + _uid"
    >
      <span style="display: none !important">{{ dateRerenderer }}</span>

      <template v-if="projectId !== false">
        <template v-for="(track, index) of tracks" v-if="tracks.length">
          <!-- We use updated_at which is on the model as it's unused on the player and saves us looping through the tracks and adding a seperate field for the in viewport-ness. -->
          <intersect
            :root="getTracklistHtmlEl()"
            :rootMargin="
              '' +
              trackListRowDefaultSize * 5 +
              'px 0px ' +
              trackListRowDefaultSize * 5 +
              'px 0px'
            "
            :threshold="[0, 0.25, 0.5, 0.75, 1]"
            @enter="onSortableIntersectEnter(track)"
            @leave="onSortableIntersectLeave(track)"
          >
            <div
              :class="{
                'in-viewport':
                  track.updated_at == true || track.forceRender == true,
              }"
              :index="index"
              :key="track.id"
              class="sortable-track-outer-container"
              v-bind:id="
                track ? 'sort-tracks-sortable-track-id-' + track.id : ''
              "
            >
              <track-list-row-wrapper
                :expanded="allSubtracksExpanded"
                :index="index"
                :key="index"
                :parentUid="_uid"
                :projectId="projectId"
                :source="track"
                :trackListRowDefaultSize="trackListRowDefaultSize"
                v-if="track.updated_at == true || track.forceRender == true"
                v-bind:asseturl="asseturl"
              ></track-list-row-wrapper>
            </div>
          </intersect>
        </template>

        <div
          v-if="
            pagination !== null &&
            pagination.next_page_url !== null &&
            shouldShowLoadMore()
          "
        >
          <intersect
            :root="getTracklistHtmlEl()"
            :rootMargin="
              '' +
              trackListRowDefaultSize * 5 +
              'px 0px ' +
              trackListRowDefaultSize * 5 +
              'px 0px'
            "
            :threshold="[0, 0.25, 0.5, 0.75, 1]"
            @enter="loadMoreElInViewport()"
          >
            <div class="my-4 text-center">
              <a
                @click.prevent="loadMoreElInViewport"
                class="btn btn-light btn-sm"
                href="#"
                >Load more Tracks</a
              >
            </div>
          </intersect>
        </div>
      </template>

      <template v-if="projectId === false">
        <virtual-list
          :data-component="itemComponent"
          :data-key="'id'"
          :data-sources="tracks"
          :estimate-size="59"
          :extra-props="{
            parentUid: _uid,
            projectId: projectId,
            isParentTrack: true,
            expanded: allSubtracksExpanded,
            trackListRowDefaultSize: trackListRowDefaultSize,
            isVirtualList: true,
            asseturl: asseturl,
          }"
          :keeps="virtualListBuffer"
          :style="{ height: trackListOverflowContainerHeight + 'px' }"
          :class="trackListClasses"
          class="virtual-track-list"
          style="overflow-y: auto"
          v-bind:ref="'virtualList' + _uid"
          v-on:tobottom="loadMoreElInViewport"
          v-show="tracks.length"
        ></virtual-list>
      </template>

      <div v-if="!tracks.length">
        <div class="card card-track-row py-4">
          <div
            v-if="loadingTracks || tracklistLoader || loaderVisible"
            class="card-header"
          >
            <span>Loading tracks...</span>
          </div>

          <div
            v-if="!loadingTracks && !tracklistLoader && !loaderVisible"
            class="card-header"
          >
            <span>No track results.</span>
          </div>
        </div>
      </div>
    </div>

    <loading
      v-if="tracklistLoader || loaderVisible"
      v-bind:label="loadingLabel()"
    ></loading>

    <div class="track-listing-footer"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import ToastrType from "../toastr-types.interface";
import trackListRow from "./track-list-row";
import trackListRowWrapper from "./track-list-row-wrapper";
import LoadingComponent from "../components/loading";
import UrlParamsRetreiver from "../url-params-retreiver";
import searchResultStore from "../search-result-store";
import VirtualList from "vue-virtual-scroll-list";
import Intersect from "vue-intersect";

export default Vue.component("track-list", {
  name: "track-list",
  data: function () {
    return {
      tracks: [],
      authenticated: window.authenticatedUserEmail,
      unprocessedTracks: [],
      pagination: null,
      collectionTotal: 0,
      waveformVisible: true,
      tracklistLoader: false,
      cachedScrollTopPosition: 0,
      quicklistReloadInProgress: false,
      loadContext: "initial", // 'initial', 'lazy-load', or 'refresh'
      trackListOverflowContainerHeight: 500,
      trackListRowDefaultSize: 59,
      allSubtracksExpanded: false,
      searchQuery: null,
      searchTimestamp: null,
      sortTime: null,
      sortAlbum: null,
      sortTrack: null,
      unnestedTracks: false,
      resourceType: false,
      resourceId: false,
      deletionInProgress: false,
      downloadAll: false,
      showLoadMore: false,
      playedTracks: 0,
      loadingTracks: false,
      dateRerenderer: Date.now(), // Some psuedo data to force rerender which will then recompute. Which will force a re-render if required, which will then recompute any computed properties.
      virtualListBuffer: 30,

      // New scroller
      itemComponent: trackListRowWrapper,
      trackListInitiallyResized: false,
      sortableSelectedTrack: null,
      onSortableIntersectEnterDebouncer: null,
      loadMoreDebounceTimer: null,
      lastSearchFiltersJson: null,
      currentLoadPromise: null,
      requestId: 0,
    };
  },

  props: {
    asseturl: {
      type: String,
      required: true,
    },

    trackResourceUrl: {
      required: true,
    },

    trackListEventId: {
      required: false,
    },

    trackListClasses: {
      type: String,
      required: false,
      default: "",
    },

    projectId: {
      required: false,
      default: false,
    },

    loaderVisible: {
      required: false,
      default: false,
    },

    searchFilters: {
      required: false,
      default: false,
    },
  },

  created: function () {
    let ctx = this;

    // For quicklist components, show loading state immediately to prevent
    // a flash of "No Track Results" before the list has loaded.
    const isQuicklistOnCreate =
      this.projectId == window.authenticatedUserQuicklistId ||
      this.projectId === "quicklistGuest";
    if (isQuicklistOnCreate) {
      this.tracklistLoader = true;
    }

    // Initialize the last search filters state
    this.lastSearchFiltersJson = JSON.stringify(this.searchFilters);

    this.debouncedLoadTrackResource = _.debounce(function (paginationDir) {
      const loadPromise = this.loadTrackResource(paginationDir);
      if (!paginationDir) {
        this.currentLoadPromise = loadPromise;
      }
      return loadPromise;
    }, 750);

    this.trackListMarginOffset = _.debounce(function () {
      let trackList = this.$el.querySelector(".track-list-accordion");

      if (
        trackList.scrollHeight > 0 &&
        trackList.scrollHeight > trackList.clientHeight
      ) {
        let normalwidth = 0;
        let scrollwidth = 0;

        let trackRow = $(trackList).find(".card-track-row");

        normalwidth = window.innerWidth;
        scrollwidth = normalwidth - trackRow.width();
      }
    }, 5000);

    /**
     * Commit new autonested tracks and album ordering.
     */
    this.commitAutoNestedTracksAndAlbums = _.debounce(function (
      masterTracks,
      masterTrackSortedAlbumIds,
    ) {
      this.tracks = masterTracks;

      if (
        this.trackListEventId == window.searchTrackResultsTrackListEventId &&
        this.trackResourceUrl.indexOf("tracksearch") != -1
      ) {
        playerService.$emit("sort-album-results", masterTrackSortedAlbumIds);
      }

      let ctx = this;

      // Only restore scroll position if not lazy loading (pagination)
      // During lazy loading, maintain natural scroll position at bottom
      if (ctx.loadContext !== "lazy-load") {
        setTimeout(function () {
          if (ctx.projectId !== false) {
            $("#trackListAccordion" + ctx._uid)
              .removeClass("no-overflow")
              .scrollTop(ctx.cachedScrollTopPosition);
          } else {
            $(".virtual-track-list").scrollTop(ctx.cachedScrollTopPosition);
          }
        }, 500);
      }
    }, 1000);

    /**
     * On browser resize, handle anything we need, like resizing the track-list.
     */
    this.onWindowResize = _.debounce(function () {
      this.resizeTrackList();
    }, 350);

    /**
     * A debouncer for refreshing sortables.
     */
    this.onSortableIntersectEnterDebouncer = _.debounce(function () {
      // Handle download visibility.
      this.handleDownloadAllBtnVisibility();
    }, 350);
  },

  updated() {
    this.trackListMarginOffset();
  },

  methods: {
    hasValidParentTrackId: function (parentTrackId) {
      return !(
        typeof parentTrackId === "undefined" ||
        parentTrackId === null ||
        parentTrackId === false ||
        parentTrackId === 0 ||
        parentTrackId === "0" ||
        parentTrackId === ""
      );
    },

    resolveCollectionTotalFromResponse: function (response) {
      const hasDurationFilter =
        this.searchFilters &&
        this.searchFilters.durationFilter !== false &&
        this.searchFilters.durationFilter !== "false";

      if (
        hasDurationFilter &&
        typeof response.message.absolute_total_exc_subtracks !== "undefined"
      ) {
        return response.message.absolute_total_exc_subtracks;
      }

      if (typeof response.message.absolute_total !== "undefined") {
        return response.message.absolute_total;
      }

      if (response.data && typeof response.data.total !== "undefined") {
        return response.data.total;
      }

      return 0;
    },

    getQuicklistCollectionTotal: function () {
      return Array.isArray(window.quicklistTrackIds)
        ? window.quicklistTrackIds.length
        : 0;
    },

    emitTrackListCollectionTotalUpdate: function (collectionTotal) {
      const eventId = this.trackListEventId || this.projectId;
      if (!eventId) {
        return;
      }

      playerService.$emit(`track-list-resource-updated-${eventId}`, {
        collectionTotal: Number(collectionTotal || 0),
      });
    },

    runQuicklistReloadOnce: function () {
      if (this.quicklistReloadInProgress) {
        return;
      }

      this.quicklistReloadInProgress = true;
      this.reload();

      // Reset guard shortly after reload is triggered to avoid duplicate rapid calls.
      this.$nextTick(() => {
        setTimeout(() => {
          this.quicklistReloadInProgress = false;
        }, 100);
      });
    },

    onSortableIntersectEnter(track) {
      // We piggy back off update_ad for displaying the track in the intersection code.
      track.updated_at = true;

      // Update sortables.
      this.onSortableIntersectEnterDebouncer();
    },

    onSortableIntersectLeave(track) {
      // console.log('onSortableIntersectLeave' + track.title);
      track.updated_at = false;
    },

    getTracklistHtmlEl() {
      return document.getElementById("trackListAccordion" + this._uid);
    },

    /**
     * Check if we should show the load more button/intersect element
     */
    shouldShowLoadMore: function () {
      // For tracksearch, check if we have all available tracks
      if (this.trackResourceUrl.indexOf("tracksearch") !== -1) {
        let currentTracksCount = this.tracks.length;
        let totalAvailable = this.collectionTotal || 0;

        // Don't show load more if we already have all tracks
        if (currentTracksCount >= totalAvailable && totalAvailable > 0) {
          return false;
        }
      }

      return true;
    },

    /**
     * When we hit the autoloader element in the viewport, load the next page of pagination if we can.
     * Ensure it uses https
     */
    loadMoreElInViewport: function () {
      if (this.loadingTracks) {
        return;
      }

      // Prevent rapid-fire calls when tracks don't fill viewport
      if (this.loadMoreDebounceTimer) {
        clearTimeout(this.loadMoreDebounceTimer);
      }

      this.loadMoreDebounceTimer = setTimeout(() => {
        this.doLoadMoreElInViewport();
      }, 300);
    },

    doLoadMoreElInViewport: function () {
      if (this.loadingTracks) {
        return;
      }

      // Load next page if available through normal pagination
      if (this.pagination !== null && this.pagination.next_page_url !== null) {
        this.pagination.next_page_url = this.pagination.next_page_url.replace(
          "http:",
          "https:",
        );
        this.loadingTracks = true;
        this.debouncedLoadTrackResource("next");
      }
      // If next_page_url is null, we've reached the end of cached results (10,000 limit)
    },

    /**
     * If project we want to manually nest our subtracks as we remove this when grabbing the collection
     */
    autoNestBrowserMode: function (cleartracks = false) {
      let masterTracks = [];
      let masterTrackSortedAlbumIds = [];
      let allTracks = [];
      let tracksWithNoParent = [];
      allTracks.push(...this.tracks);
      allTracks.push(...this.unprocessedTracks);

      // Clear the current tracks array on the track list.
      if (cleartracks === true) {
        this.tracks = [];
      }

      this.unprocessedTracks = [];

      let autoNestTracksEnabled = true;

      if (
        this.trackListEventId != window.searchTrackResultsTrackListEventId ||
        this.trackListEventId == "quicklistGuest" ||
        this.projectId != false ||
        this.unnestedTracks == true
      ) {
        autoNestTracksEnabled = false;
      }

      if (autoNestTracksEnabled === true) {
        // Loop through the tracks & store all the parent tracks first.
        for (let trackIndex in allTracks) {
          if (
            allTracks.hasOwnProperty(trackIndex) &&
            typeof allTracks[trackIndex] != "undefined"
          ) {
            if (
              !this.hasValidParentTrackId(
                allTracks[trackIndex]["parent_track_id"],
              )
            ) {
              // Add the master track.
              masterTracks.push(allTracks[trackIndex]);

              // Keep track of the album ordering.
              masterTrackSortedAlbumIds.push(allTracks[trackIndex]["album_id"]);
            }
          }
        }

        // Loop through the tracks again, skipping parent tracks and processing subtracks only.
        for (let subtrackIndex in allTracks) {
          if (
            // Check if this is a valid entry in the allTracks array.
            allTracks.hasOwnProperty(subtrackIndex) &&
            typeof allTracks[subtrackIndex] != "undefined" &&
            // Check if this is a subtrack or parent track.
            this.hasValidParentTrackId(
              allTracks[subtrackIndex]["parent_track_id"],
            )
          ) {
            // This is a subtrack.
            let subtrack = allTracks[subtrackIndex];

            // Get the subtracks parent Track ID.
            let parentTrackId = subtrack["parent_track_id"];

            let validParentTrackFound = false;

            // Step 1 - Find the parent
            for (let parentTrackIndex in masterTracks) {
              if (
                // Check if it's valid.
                masterTracks.hasOwnProperty(parentTrackIndex) &&
                typeof masterTracks[parentTrackIndex] != "undefined" &&
                // Check if it's the parent track that we want.
                masterTracks[parentTrackIndex]["id"] == parentTrackId
              ) {
                validParentTrackFound = true;
                // Step 2 - Add this subtrack into the parent Track.

                let parentTrack = masterTracks[parentTrackIndex];

                // If no subtracks array on the parent track, create it ready for our subtrack addition(s).
                if (typeof parentTrack["subtracks"] == "undefined") {
                  parentTrack["subtracks"] = [];
                }

                // Check if this track doesn't already exist in the subtracks. No dupes!

                let parentHasCurrentSubtrack = false;

                for (let parentTrackSubtracksIndex in parentTrack[
                  "subtracks"
                ]) {
                  if (
                    parentTrack["subtracks"].hasOwnProperty(
                      parentTrackSubtracksIndex,
                    )
                  ) {
                    if (
                      parentTrack["subtracks"][parentTrackSubtracksIndex][
                        "id"
                      ] == subtrack["id"]
                    ) {
                      parentHasCurrentSubtrack = true;
                    }
                  }
                }

                // Add the track to the parent subtrack if it's not dupe. The above loops/checks through all subtracks.
                if (parentHasCurrentSubtrack == false) {
                  // Add this track to the subtracks.
                  parentTrack["subtracks"].push(
                    jQuery.extend(true, {}, subtrack),
                  );

                  setTimeout(function () {
                    $(".collapse-track-" + parentTrackId).addClass(
                      "has-subtracks",
                    );
                  }, 2000);
                }
              }
            }

            // If no valid parent track was found, then add it as a "master" track itself.
            if (validParentTrackFound === false) {
              if (
                // Check if it's already been attempted to nest in this situation..
                tracksWithNoParent.hasOwnProperty(subtrack.parent_track_id) &&
                typeof tracksWithNoParent[subtrack.parent_track_id] !=
                  "undefined"
              ) {
                if (
                  typeof tracksWithNoParent[subtrack.parent_track_id][
                    "subtracks"
                  ] == "undefined"
                ) {
                  tracksWithNoParent[subtrack.parent_track_id]["subtracks"] =
                    [];
                }

                tracksWithNoParent[subtrack.parent_track_id]["subtracks"].push(
                  jQuery.extend(true, {}, subtrack),
                );
              } else {
                tracksWithNoParent[subtrack.parent_track_id] = subtrack;
              }
            }
          }
        }

        // If no parents exist but there are multiple subtracks, nest them into the first one.

        for (let tracksWithNoParentIndex in tracksWithNoParent) {
          if (
            tracksWithNoParent.hasOwnProperty(tracksWithNoParentIndex) &&
            typeof tracksWithNoParent[tracksWithNoParentIndex] != "undefined"
          ) {
            // Add the master track.
            masterTracks.push(tracksWithNoParent[tracksWithNoParentIndex]);
          }
        }
      } else {
        for (let trackIndex in allTracks) {
          if (
            allTracks.hasOwnProperty(trackIndex) &&
            typeof allTracks[trackIndex] != "undefined"
          ) {
            // Add the master track.
            masterTracks.push(allTracks[trackIndex]);

            // Keep track of the album ordering.
            masterTrackSortedAlbumIds.push(allTracks[trackIndex]["album_id"]);
          }
        }
      }

      let ctx = this;

      this.showLoadMore = false;

      setTimeout(function () {
        ctx.showLoadMore = true;
      }, 1500);

      this.commitAutoNestedTracksAndAlbums(
        masterTracks,
        masterTrackSortedAlbumIds,
      );
    },

    /**
     * Toggle the waveform from being displayed.
     */
    toggleWaveform: function () {
      window.waveformvisible = this.waveformVisible = !this.waveformVisible;

      playerService.$emit("waveform-toggled", this.waveformVisible);
    },

    // On clicking the Load More button at the bottomm of the album results.
    onLoadMoreClick() {
      this.debouncedLoadTrackResource("next");
    },

    // get the text for the loading label
    loadingLabel() {
      return (this.trackResourceUrl &&
        this.trackResourceUrl.includes("find-similar")) ||
        (this.searchQuery && this.searchQuery.includes("http"))
        ? "Loading - Finding similar tracks"
        : "Loading - Track list updating";
    },

    /**
     * Resize the height of the track-list container of page height minus headers.
     */
    resizeTrackList: function () {
      let pageHeader = $(".player-app-container > .header").outerHeight(true);
      let playerHeader = $(
        ".player-app-container .player-header-container",
      ).outerHeight(true);
      let audioPlayer = $(
        ".player-app-container .audio-player-container",
      ).outerHeight(true);
      let tabsContainer = $(
        ".player-app-container .player-tabs-container",
      ).outerHeight(true);
      let trackListingHeader = $(this.$el)
        .find(".track-listing-header")
        .outerHeight(true);
      let bodyHeight = $("body").innerHeight();
      let totalUsedHeight = Math.ceil(
        pageHeader +
          playerHeader +
          audioPlayer +
          tabsContainer +
          trackListingHeader,
      );

      this.trackListOverflowContainerHeight =
        Math.floor(bodyHeight - totalUsedHeight) - 1;
    },

    updatedSortable: function (context, projectId) {
      let $sortableEl = window
        .jqueryWrapper(this.$el)
        .find(".track-list-accordion");

      // Sort and set.
      let rawSortedTracks = window.sortableToArrayWrapper($sortableEl);
      let sortedTrackIds = [];
      rawSortedTracks.forEach(function (value, index) {
        let sortedTrackData = {
          id: value.replace("sort-tracks-sortable-track-id-", ""),
          order: index,
        };

        sortedTrackIds.push(sortedTrackData);
      });

      if (!rawSortedTracks) {
        return false;
      }

      playerService.saveProjectTrackOrdering(projectId, sortedTrackIds);

      let ctx = this;

      for (let trackIndex in this.tracks) {
        if (this.tracks.hasOwnProperty(trackIndex)) {
          this.tracks[trackIndex].forceRender = true;
        }
      }

      Vue.nextTick().then(() => {
        this.dateRerenderer = Date.now();
      });
    },

    /**
     * Loads the track resource, expects a well formed laravel collection with pagination (even if only single page for uniformity).
     *
     * @param paginationDir
     * @returns {boolean}
     */
    loadTrackResource: function (paginationDir = false) {
      // Return a promise for the entire operation
      const requestId = ++this.requestId;

      // A direct load supersedes one still waiting in the debounce, such as the load queued at mount.
      if (
        !paginationDir &&
        this.debouncedLoadTrackResource &&
        typeof this.debouncedLoadTrackResource.cancel === "function"
      ) {
        this.debouncedLoadTrackResource.cancel();
      }
      return new Promise((resolve, reject) => {
        // Garbage coll / vue not finished removing this yet.
        if (this.deletionInProgress == true) {
          return resolve(false);
        }

        if (
          this.trackResourceUrl == "" &&
          this.projectId == "quicklistGuest" &&
          window.authenticatedUserEmail == false
        ) {
          // Changes are handled/refreshed by the event thrown/caught.
          return resolve(false);
        }

        if (window.trackAndAlbumCancelledSteps !== false) {
          window.trackAndAlbumCancelledSteps.track = true;

          if (
            window.trackAndAlbumCancelledSteps.track === true &&
            window.trackAndAlbumCancelledSteps.album === true
          ) {
            window.trackAndAlbumCancelledSteps = false;
          }
        }

        if (
          typeof this.trackResourceUrl == "undefined" ||
          this.trackResourceUrl == false
        ) {
          /*playerService.toast(
                       '[PLYR_21419] Error: Could not load track resource into track list. Invalid track resource url given.',
                       ToastrType.Error
                       );*/

          return resolve(false);
        }

        // Lets assume we don't want an error but we don't want to load the track resource for this trakc list yet.
        if (this.trackResourceUrl == "") {
          // Clear loading state since we're not actually loading anything
          this.tracklistLoader = false;
          return resolve(false);
        }

        // Figure out if we need to set the initial size of the tracklist.
        if (!this.trackListInitiallyResized) {
          this.resizeTrackList();
        }

        // Filter out dupe timestamped search queries.
        let parsedUrlParams = UrlParamsRetreiver.get(this.trackResourceUrl);

        // Priority order, check if we need to do anything from the current route.
        if (typeof parsedUrlParams["timestamp"] != "undefined") {
          this.searchTimestamp = parsedUrlParams["timestamp"];
        } else {
          this.searchTimestamp = null;
        }

        // Empty search query with no active filters — don't fire a tracksearch request.
        const noSearchQuery = !this.searchQuery || this.searchQuery === "";
        const sf = this.searchFilters;
        const noActiveFilters =
          !sf ||
          Array.isArray(sf) ||
          (!sf.durationFilter &&
            (!sf.filterByFilters || sf.filterByFilters.length === 0) &&
            (!sf.searchByFilters || sf.searchByFilters.length === 0) &&
            sf.excludeVocalTracks !== true);

        if (
          this.trackListEventId == window.searchTrackResultsTrackListEventId &&
          this.trackResourceUrl.indexOf("tracksearch") != -1 &&
          this.trackResourceUrl.indexOf("composer") == -1 &&
          noSearchQuery &&
          noActiveFilters
        ) {
          // No query or filters — nothing to search for yet.
          this.reset();
          searchResultStore.clear();
          return resolve(false);
        }

        let ctx = this;
        let loadTrackUrl = this.trackResourceUrl;
        this.tracklistLoader = true;

        if (paginationDir == "next") {
          if (
            this.pagination != null &&
            this.pagination.next_page_url != null
          ) {
            loadTrackUrl = this.pagination.next_page_url;
          } else {
            this.tracklistLoader = false;
            return resolve(false);
          }
        } else if (paginationDir == "prev") {
          if (
            this.pagination != null &&
            this.pagination.prev_page_url != null
          ) {
            loadTrackUrl = this.pagination.prev_page_url;
          } else {
            this.tracklistLoader = false;
            return resolve(false);
          }
        }

        let sortByVal = "";

        if (this.sortTime == true) {
          sortByVal = "timeasc";
        } else if (this.sortTime == false) {
          sortByVal = "timedesc";
        } else if (this.sortAlbum == true) {
          sortByVal = "albumasc";
        } else if (this.sortAlbum == false) {
          sortByVal = "albumdesc";
        } else if (this.sortTrack == true) {
          sortByVal = "trackasc";
        } else if (this.sortTrack == false) {
          sortByVal = "trackdesc";
        } else if (
          this.sortAlbum == null &&
          this.sortTime == null &&
          this.sortTrack == null
        ) {
          sortByVal = "";
        }

        let ajaxConfig = {
          method: "GET",
          url: loadTrackUrl,
          cache: false,
          data: {
            sortby: sortByVal,
          },
        };

        if (
          this.trackListEventId == window.searchTrackResultsTrackListEventId &&
          loadTrackUrl.indexOf("tracksearch") != -1
        ) {
          // Our main search track listing searches slightly different.

          var shouldNest = true;

          if (
            this.trackListEventId !=
              window.searchTrackResultsTrackListEventId ||
            this.trackListEventId == "quicklistGuest" ||
            this.projectId != false ||
            this.unnestedTracks == true
          ) {
            shouldNest = false;
          }

          ajaxConfig = {
            method: "POST",
            url: loadTrackUrl,
            data: {
              query: ctx.searchQuery,
              filters: ctx.searchFilters,
              nestable: shouldNest,
            },
            headers: {
              "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            cache: false,
          };

          if (
            Array.isArray(ajaxConfig.data.filters) &&
            !ajaxConfig.data.filters.length
          ) {
            ajaxConfig.data.filters = {};
          }

          ajaxConfig.data.filters["sortby"] = sortByVal;
        }

        const isSearchList =
          this.trackListEventId == window.searchTrackResultsTrackListEventId;

        // Later pages of a list search send the page's ids, not the search.
        const listPage =
          isSearchList &&
          paginationDir == "next" &&
          loadTrackUrl.indexOf("/tracksearch/page") != -1
            ? searchResultStore.pageRequest(
                parseInt(UrlParamsRetreiver.get(loadTrackUrl)["page"], 10) || 1,
                this.pagination.per_page || 50,
              )
            : null;

        if (listPage) {
          ajaxConfig = {
            method: "POST",
            url: loadTrackUrl,
            contentType: "application/json",
            data: JSON.stringify(listPage),
            headers: {
              "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
          };
        }

        // Set load context based on pagination direction
        if (paginationDir == "next" || paginationDir == "prev") {
          this.loadContext = "lazy-load";
        } else {
          // Initial load or refresh
          this.loadContext = "initial";
        }

        // Only cache scroll position when not doing lazy loading
        if (this.loadContext !== "lazy-load") {
          this.cachedScrollTopPosition = $(
            "#trackListAccordion" + this._uid,
          ).scrollTop();
        }

        playerService.$emit(
          "track-list-preajax-load-resource-" + ctx.trackListEventId,
        );

        // One navigation fires both resource watchers; share an identical in-flight search instead of repeating it.
        const inflightKey =
          isSearchList && !paginationDir && ajaxConfig.method === "POST"
            ? JSON.stringify([ajaxConfig.url, ajaxConfig.data])
            : null;
        let request;

        if (
          inflightKey &&
          ctx.inflightSearch &&
          ctx.inflightSearch.key === inflightKey
        ) {
          request = ctx.inflightSearch.request;
        } else {
          request = $.ajax(ajaxConfig);
          if (inflightKey) {
            const inflight = { key: inflightKey, request };
            ctx.inflightSearch = inflight;
            request.always(function () {
              if (ctx.inflightSearch === inflight) {
                ctx.inflightSearch = null;
              }
            });
          }
        }

        request
          .done(function (response) {
            // We expect the pagination and track data to be inside the 'data' object. Outside of it should be response and status information.
            if (
              typeof response.data !== "undefined" &&
              typeof response.data.data !== "undefined"
            ) {
              let tracksReturned = response.data.data;
              // Kept out of reactive data: Vue would observe every id.
              const { results: resultList, ...paginationData } = response.data;

              if (
                typeof ctx.searchFilters != "undefined" &&
                typeof ctx.searchFilters.filterByFilters != "undefined"
              ) {
                for (let filterI in ctx.searchFilters.filterByFilters) {
                  if (
                    ctx.searchFilters.filterByFilters.hasOwnProperty(filterI) &&
                    typeof ctx.searchFilters.filterByFilters[filterI] !=
                      "undefined"
                  ) {
                    if (
                      ctx.searchFilters.filterByFilters[filterI]["id"] ==
                      "composer"
                    ) {
                      playerService.$emit("composer-track-collection-updated");
                    }
                  }
                }
              }

              // Issue with the virtual scroll not displaying last item so add another one as a buffer at the bottom of virtual list.
              ctx.pagination = paginationData;

              // A list page carries no search totals; keep page 1's.
              if (!listPage) {
                ctx.collectionTotal =
                  ctx.resolveCollectionTotalFromResponse(response);
              }

              if (
                isSearchList &&
                !paginationDir &&
                ctx.requestId === requestId
              ) {
                if (resultList) {
                  searchResultStore.save({
                    search: {
                      query: ctx.searchQuery,
                      filters: JSON.parse(JSON.stringify(ctx.searchFilters || {})),
                      url: ctx.trackResourceUrl,
                    },
                    results: resultList,
                    totals: {
                      total: paginationData.total,
                      absolute_total: response.message.absolute_total,
                      absolute_total_exc_subtracks:
                        response.message.absolute_total_exc_subtracks,
                      album_ids_count: paginationData.album_ids_count,
                      source: paginationData.source,
                    },
                  });
                } else {
                  searchResultStore.clear();
                }
              }

              let oldTracks = ctx.tracks;
              let cleartracks = false;

              if (ctx.pagination.current_page == 1) {
                // First page - replace all tracks
                ctx.tracks = [...tracksReturned];
                cleartracks = true;
              } else {
                // Subsequent pages - append only new tracks to avoid duplicates
                let existingTrackIds = new Set(
                  oldTracks.map((track) => track.id),
                );
                let newTracks = tracksReturned.filter(
                  (track) => !existingTrackIds.has(track.id),
                );
                ctx.tracks = [...oldTracks, ...newTracks];
              }

              ctx.updateTrackCache(response.data.data);

              // Restore scroll position without re-processing tracks (tracks already set above)
              // Skip restoration during lazy loading to maintain natural scroll position
              if (ctx.loadContext !== "lazy-load") {
                setTimeout(function () {
                  if (ctx.projectId !== false) {
                    $("#trackListAccordion" + ctx._uid)
                      .removeClass("no-overflow")
                      .scrollTop(ctx.cachedScrollTopPosition);
                  } else {
                    $(".virtual-track-list").scrollTop(
                      ctx.cachedScrollTopPosition,
                    );
                  }
                }, 500);
              }

              // If we have a track list event id set, let's emit some data to it incase. If one isn't set they don't want to listen to any events emitted from this.
              if (ctx.trackListEventId) {
                if (ctx.playedTracks) {
                  playerService.$emit(
                    "track-list-resource-updated-" + ctx.trackListEventId,
                    {
                      collectionTotal: ctx.playedTracks,
                    },
                  );

                  ctx.playedTracks = 0;
                } else {
                  playerService.$emit(
                    "track-list-resource-updated-" + ctx.trackListEventId,
                    {
                      collectionTotal: ctx.collectionTotal,
                    },
                  );
                }
              }

              if (ctx.requestId !== requestId) {
                return resolve(false);
              }

              // Resolve the promise with success data including album count from backend
              resolve({
                success: true,
                response,
                collectionTotal: ctx.collectionTotal,
                albumIdsCount: response.data.album_ids_count || 0,
                albumIds: resultList ? resultList.album_ids : undefined,
                requestId,
              });
            } else {
              if ((window.adminProjectShare = true)) {
                playerService.toast(
                  `[PLYR_21427] Error: Track Resource response was obtained but invalidated data schema was provided.`,
                  ToastrType.Error,
                );
              }

              resolve(false);
            }
          })
          .fail(function (responseData) {
            // Aborted (status 0) — treat as cancelled, not an error
            if (responseData.status === 0) {
              return resolve(false);
            }

            // A task still on the pre-list release has no /tracksearch/page: page by re-posting the search.
            if (
              listPage &&
              (responseData.status === 404 || responseData.status === 405)
            ) {
              searchResultStore.clear();
              ctx.pagination.next_page_url = loadTrackUrl.replace(
                "/tracksearch/page",
                "/tracksearch",
              );
              return resolve(ctx.loadTrackResource("next"));
            }

            if (
              typeof responseData.status !== "undefined" &&
              responseData.status == 419
            ) {
              // CSRF issue/Timed out/logged out, idled too long.
              playerService.$emit("open-browser-idle-too-long-modal");
            } else if (
              typeof responseData.status !== "undefined" &&
              responseData.status == 404
            ) {
              playerService.$emit(
                "track-list-resource-failed",
                responseData.responseJSON.message,
              );
            } else {
              // Show error for other failures
              playerService.toast(
                `[PLYR_41648] Error: Could not load Tracks.`,
                ToastrType.Error,
              );
            }

            // Reject the promise with error data
            reject(responseData);
          })
          .always(function (responseData) {
            ctx.tracklistLoader = false;
            ctx.loadingTracks = false;
          });
      }); // Close the Promise wrapper
    },

    // Update our Track Cache for this Track List in the Player Service.
    updateTrackCache: function (newTracks) {
      let allTracksUnprocessed = [];
      let trackListCacheAll = playerService.getTrackListCache("all");
      let trackCacheId = "all";

      if (trackListCacheAll == false) {
        trackListCacheAll = {};
      }

      allTracksUnprocessed.push(...this.tracks);
      allTracksUnprocessed.push(...newTracks);

      for (let trackIndex in allTracksUnprocessed) {
        if (
          allTracksUnprocessed.hasOwnProperty(trackIndex) &&
          typeof allTracksUnprocessed[trackIndex] != "undefined" &&
          typeof allTracksUnprocessed[trackIndex].id != "undefined"
        ) {
          // Check if this is now already in our processed tracks array. If not add it.
          if (
            typeof trackListCacheAll[allTracksUnprocessed[trackIndex].id] ==
            "undefined"
          ) {
            // Add it to the processed array.
            playerService.addToTrackCache(
              trackCacheId,
              allTracksUnprocessed[trackIndex].id,
              allTracksUnprocessed[trackIndex],
            );

            // Loop through the subtracks and add these too.
            if (
              typeof allTracksUnprocessed[trackIndex].subtracks != "undefined"
            ) {
              for (let subtrackIndex in allTracksUnprocessed[trackIndex]
                .subtracks) {
                if (
                  allTracksUnprocessed[trackIndex].subtracks.hasOwnProperty(
                    subtrackIndex,
                  ) &&
                  typeof allTracksUnprocessed[trackIndex].subtracks[
                    subtrackIndex
                  ] != "undefined" &&
                  typeof allTracksUnprocessed[trackIndex].subtracks[
                    subtrackIndex
                  ].id != "undefined"
                ) {
                  // Check if this is now already in our processed tracks array. If not add it.
                  if (
                    typeof trackListCacheAll[
                      allTracksUnprocessed[trackIndex].subtracks[subtrackIndex]
                        .id
                    ] == "undefined"
                  ) {
                    // Add it to the processed array.
                    playerService.addToTrackCache(
                      trackCacheId,
                      allTracksUnprocessed[trackIndex].subtracks[subtrackIndex]
                        .id,
                      allTracksUnprocessed[trackIndex].subtracks[subtrackIndex],
                    );
                  }
                }
              }
            }
          }
        }
      }
    },

    sortbyTime: function () {
      if (this.sortAlbum == true || this.sortAlbum == false) {
        this.sortAlbum = null;
      }
      if (this.sortTrack == true || this.sortTrack == false) {
        this.sortTrack = null;
      }
      if (this.sortTime == null) {
        this.sortTime = true;
      } else if (this.sortTime == true) {
        this.sortTime = false;
      } else if (this.sortTime == false) {
        this.sortTime = null;
      }
      this.reset();
      this.reload();
    },

    sortbyAlbum: function () {
      if (this.sortTime == true || this.sortTime == false) {
        this.sortTime = null;
      }
      if (this.sortTrack == true || this.sortTrack == false) {
        this.sortTrack = null;
      }
      if (this.sortAlbum == null) {
        this.sortAlbum = true;
      } else if (this.sortAlbum == true) {
        this.sortAlbum = false;
      } else if (this.sortAlbum == false) {
        this.sortAlbum = null;
      }
      this.reset();
      this.reload();
    },

    sortbyTrack: function () {
      if (this.sortTime == true || this.sortTime == false) {
        this.sortTime = null;
      }
      if (this.sortAlbum == true || this.sortAlbum == false) {
        this.sortAlbum = null;
      }
      if (this.sortTrack == null) {
        this.sortTrack = true;
      } else if (this.sortTrack == true) {
        this.sortTrack = false;
      } else if (this.sortTrack == false) {
        this.sortTrack = null;
      }
      this.reset();
      this.reload();
    },

    clearSorting: function (reloadCollection = false) {
      this.sortAlbum = null;

      this.sortTime = null;

      this.sortTrack = null;

      if (reloadCollection === true) {
        this.reset();
        this.reload();
      }
    },

    reload: function () {
      // Reset all current track related information.
      this.reset();

      // Show loader immediately to prevent "No track results" flash during debounce delay.
      this.tracklistLoader = true;

      // Kickoff the loader to get the new tracks.
      this.debouncedLoadTrackResource();
    },

    toggleSubtrackCollapse: function () {
      if (this.allSubtracksExpanded == true) {
        this.collapseSubtracks();
      } else {
        this.expandSubtracks();
      }
    },

    expandSubtracks: function () {
      // Set our master state, useful for showing our toggle all caret in the right way on the track header row.
      this.allSubtracksExpanded = true;

      // Set all the tracks as expanded.
      if (typeof window.tracklistExpandedCache == "undefined") {
        window.tracklistExpandedCache = [];
      } else if (
        typeof window.tracklistExpandedCache[this._uid] == "undefined"
      ) {
        window.tracklistExpandedCache[this._uid] = [];
      }

      for (let trackIndex in this.tracks) {
        if (
          this.tracks.hasOwnProperty(trackIndex) &&
          typeof this.tracks[trackIndex] != "undefined"
        ) {
          window.tracklistExpandedCache[this._uid][
            this.tracks[trackIndex]["id"]
          ] = true;
        }
      }
    },

    collapseSubtracks: function () {
      // Set our master state, useful for showing our toggle all caret in the right way on the track header row.
      this.allSubtracksExpanded = false;

      if (typeof window.tracklistExpandedCache == "undefined") {
        window.tracklistExpandedCache = [];
      } else if (
        typeof window.tracklistExpandedCache[this._uid] == "undefined"
      ) {
        window.tracklistExpandedCache[this._uid] = [];
      }

      for (let trackIndex in this.tracks) {
        if (
          this.tracks.hasOwnProperty(trackIndex) &&
          typeof this.tracks[trackIndex] != "undefined"
        ) {
          window.tracklistExpandedCache[this._uid][
            this.tracks[trackIndex]["id"]
          ] = false;
        }
      }
    },

    renderQuicklistLS: function () {
      if (window.authenticatedUserEmail == false) {
        // Get the current guest quicklist.
        let quicklistGuestLS = playerService.getLs("quicklistguest");

        let quicklistGuest;

        // Doesn't exist or is just an empty string, convert to an array.
        if (quicklistGuestLS == "") {
          quicklistGuest = [];
        } else {
          quicklistGuest = JSON.parse(quicklistGuestLS);
        }

        this.tracks = [];
        this.unprocessedTracks = [];
        this.unprocessedTracks = quicklistGuest;
        this.pagination = null;
        this.collectionTotal = quicklistGuest.length;

        // Keep the loader visible until the quicklist tracks are committed and
        // the next DOM update completes. Hiding it earlier causes a
        // "No Track Results" flash.
        this.tracklistLoader = true;

        let ctx = this;

        Vue.nextTick(() => {
          ctx.autoNestBrowserMode();

          // Run the normally debounced commit immediately for this guest quicklist path.
          ctx.commitAutoNestedTracksAndAlbums.flush();

          Vue.nextTick(() => {
            ctx.tracklistLoader = false;
          });
        });
      }
    },

    downloadSharedProject() {
      let parsedUrlParams = UrlParamsRetreiver.get(window.location.href);

      if (typeof parsedUrlParams["view-shared-project"] !== "undefined") {
        // Shared Project.
        this.resourceType = "project";
        this.resourceId = parsedUrlParams["view-shared-project"];
      } else if (
        typeof parsedUrlParams["view-shared-quicklist"] !== "undefined"
      ) {
        // Shared Guest Quicklist
        this.resourceType = "project";
        this.resourceId = parsedUrlParams["view-shared-quicklist"];
      }

      playerService.$emit(
        "download-shared-tracks",
        this.resourceType,
        this.resourceId,
      );

      if (
        typeof parsedUrlParams["allow-guest-download"] !== "undefined" &&
        parsedUrlParams["allow-guest-download"] == "true"
      ) {
        this.downloadAll = false;
      }
    },

    disabledDownloadAll() {
      if (!this.authenticated) {
        playerService.$emit("feature-requires-auth-modal");
      } else {
        playerService.toast(
          `'Allow downloading' has not been set on this shared project.`,
          ToastrType.Error,
        );
      }
    },

    reset: function () {
      this.requestId++;
      this.tracks = [];
      this.unprocessedTracks = [];
      this.pagination = null;
      this.collectionTotal = 0;
      this.tracklistLoader = false;
      playerService.$emit(
        "track-list-resource-updated-" + this.trackListEventId,
        { collectionTotal: this.playedTracks },
      );
      if (this.projectId === false) {
        this.$refs["virtualList" + this._uid].reset();
      }

      if (typeof window.tracklistExpandedCache == "undefined") {
        window.tracklistExpandedCache = [];
      }

      window.tracklistExpandedCache[this._uid] = [];

      if (this.trackResourceUrl.indexOf("playlists") != -1) {
        if (!$(".track-listing-container").hasClass("playlist-tracks")) {
          $(".track-listing-container").addClass("playlist-tracks");
        }
      } else {
        if ($(".track-listing-container").hasClass("playlist-tracks")) {
          $(".track-listing-container").removeClass("playlist-tracks");
        }
      }

      let ctx = this;

      $("#search-track-results-tab").click(function () {
        console.log(ctx.trackResourceUrl);

        if (ctx.trackResourceUrl.indexOf("playlists") != -1) {
          if (!$(".track-listing-container").hasClass("playlist-tracks")) {
            $(".track-listing-container").addClass("playlist-tracks");
          }
        }
      });
    },

    handleDownloadAllBtnVisibility: function () {
      let $currentEl = window.jqueryWrapper(this.$el);

      if (this.downloadAll == true) {
        $currentEl.find(".row-download-button").addClass("guest-download");
      } else {
        if (
          $currentEl.find(".row-download-button").hasClass("guest-download")
        ) {
          $currentEl.find(".row-download-button").removeClass("guest-download");
        }
      }
    },
  },

  mounted: function () {
    // Clear track results immediately when new search starts excluding quicklist
    playerService.$on("clear-track-results", () => {
      const isQuicklist =
        this.projectId == window.authenticatedUserQuicklistId ||
        this.projectId === "quicklistGuest";
      if (!isQuicklist) {
        this.reset();
      }
    });

    let ctx = this;

    // Configure all outgoing Ajax requests
    $.ajaxSetup({
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      },
      cache: false,
    });

    // Keep the state of our waveform toggled.
    this.waveformVisible = window.waveformvisible;

    playerService.$on("waveform-toggled", (waveformVisibility) => {
      this.waveformVisible = waveformVisibility;
    });

    playerService.$on(
      "search-query-updated",
      (query, cancelCollectionReload = false) => {
        if (
          ctx.trackListEventId == window.searchTrackResultsTrackListEventId ||
          ctx.trackResourceUrl.indexOf("tracksearch") != -1
        ) {
          this.searchQuery = query;

          if (cancelCollectionReload === false) {
            // Clear our current tracks as we don't want to add any different tracks on the end.
            this.tracks = [];
          }
        }
      },
    );

    playerService.$on("loader-text-show", () => {
      this.loadingTracks = true;

      setTimeout(function () {
        ctx.loadingTracks = false;
      }, 2000);
    });

    // Setup event listener for when we resize browser.
    // window.addEventListener( 'resize', this.onWindowResize );
    window.addEventListener("resize", () => {
      this.onWindowResize();
    });

    this.tracklistLoader = true;
    this.debouncedLoadTrackResource();

    // Set the correct size of the track listing from the get-go.
    this.resizeTrackList();

    $(function () {
      // BEGIN THE OLD SORTABLE

      if (this.projectId !== false) {
        window.sortableWrapper(
          window.jqueryWrapper(ctx.$el).find(".track-list-accordion"),
          {
            placeholder: "ui-state-highlight",
            update: function (event, ui) {
              ctx.updatedSortable(ctx, ctx.projectId);
            },
            handle: ".drag-track",
            items: ".sortable-track-outer-container",
            axis: "y",
          },
        );
      }

      // END THE OLD SORTABLE
    });

    playerService.$on("show-track-results-for-id", () => {
      ctx.reload();
    });

    /*  playerService.$on( 'open-composer-tracks', () => {

             ctx.reload();

             } );*/

    if (this.projectId !== false) {
      playerService.$on("project-deleted", (projectId) => {
        if (projectId == this.projectId) {
          $("#project" + this.projectId + "-tab")
            .parent()
            .remove();

          this.deletionInProgress = true;
          this.$destroy();
        }
      });
    }

    playerService.$on("reload-track-list", () => {
      ctx.reload();
    });

    playerService.$on("quicklist-updated", () => {
      ctx.reload();
    });

    if (this.trackResourceUrl === "" && this.projectId == "quicklistGuest") {
      playerService.$on("quicklist-guest-ls-updated", this.renderQuicklistLS);
    } else {
      playerService.$off("quicklist-guest-ls-updated", this.renderQuicklistLS);
    }

    let parsedUrlParams = UrlParamsRetreiver.get(window.location.href);

    if (typeof parsedUrlParams["view-shared-project"] !== "undefined") {
      ctx = this;

      this.resourceType = "project";
      this.resourceId = parsedUrlParams["view-shared-project"];

      $.ajax({
        method: "GET",
        url: `/api/projects/getid/${ctx.resourceId}`,
        cache: false,
      })
        .done(function (source) {
          let project = source.data;

          if (!project.guest_download) {
            if (window.authenticatedUserEmail != false) {
              ctx.downloadAll = true;
            } else {
              ctx.downloadAll = false;
            }
          } else {
            let currentDate = new Date();
            let shareUntil = new Date(project.share_until);

            if (shareUntil < currentDate) {
              ctx.downloadAll = false;
            } else {
              ctx.downloadAll = true;
            }

            if (
              typeof parsedUrlParams["allow-guest-download"] !== "undefined" &&
              parsedUrlParams["allow-guest-download"] == "true"
            ) {
              ctx.handleDownloadAllBtnVisibility();
            }
          }
        })
        .fail(function (responseData) {
          console.log("fail", responseData);
          ctx.downloadAll = false;
        });
    } else if (
      typeof parsedUrlParams["view-shared-quicklist"] !== "undefined"
    ) {
      if (
        typeof parsedUrlParams["allow-guest-download"] !== "undefined" &&
        parsedUrlParams["allow-guest-download"] == "true"
      ) {
        this.downloadAll = true;
      }

      this.resourceType = "project";
      this.resourceId = parsedUrlParams["view-shared-quicklist"];
    }

    playerService.$on("reset-sorting", (reloadCollection) => {
      this.clearSorting(reloadCollection);

      this.downloadAll = false;
    });

    playerService.$on("disable-project-download", () => {
      this.downloadAll = false;

      if ($(".row-download-button").hasClass("guest-download")) {
        $(".row-download-button").removeClass("guest-download");
      } else {
      }
    });

    if (this.projectId !== false) {
      playerService.$on("project-updated-" + this.projectId, (project) => {
        const isQuicklist =
          this.projectId == window.authenticatedUserQuicklistId ||
          this.projectId === "quicklistGuest";

        if (isQuicklist) {
          // Update quicklistTrackIds if provided
          if (typeof project.trackids !== "undefined") {
            window.quicklistTrackIds = project.trackids;
          }

          // Update count badge immediately
          this.emitTrackListCollectionTotalUpdate(
            this.getQuicklistCollectionTotal(),
          );

          // Force re-render for quicklist to update CSS classes (white -> green)
          for (const trackIndex in this.tracks) {
            if (Object.prototype.hasOwnProperty.call(this.tracks, trackIndex)) {
              this.tracks[trackIndex].forceRender = true;
            }
          }
          this.dateRerenderer = Date.now();

          // Filter any quicklist updates and only do it when we're changing tab (the forceUpdate is kicked in)
          if (
            typeof project.forceUpdate != "undefined" &&
            project.forceUpdate == true
          ) {
            this.runQuicklistReloadOnce();
          }
        } else {
          // Any other projects, reload after update.
          this.reload();
        }
      });
      // Remove tracks from the current project or quicklist without reload
      playerService.$on(`project-remove-track-${this.projectId}`, (trackId) => {
        const isQuicklist =
          this.projectId == window.authenticatedUserQuicklistId ||
          this.projectId === "quicklistGuest";

        if (isQuicklist) {
          // For quicklist: just re-render to update CSS classes (green -> white)
          this.tracks.forEach((track) => (track.forceRender = true));
          this.dateRerenderer = Date.now();
        } else {
          // For projects: remove the track from the visible list
          const idx = this.tracks.findIndex(
            (t) => Number(t.id) === Number(trackId),
          );
          if (idx !== -1) {
            this.tracks.splice(idx, 1);
            this.collectionTotal = Math.max(
              0,
              Number(this.collectionTotal || 0) - 1,
            );

            // Force re-render all remaining tracks to update the UI
            this.tracks.forEach((track) => (track.forceRender = true));
            this.dateRerenderer = Date.now();
          }
        }

        // Update tab count
        this.emitTrackListCollectionTotalUpdate(
          isQuicklist
            ? this.getQuicklistCollectionTotal()
            : this.collectionTotal,
        );
      });

      // Complete removal of white quicklist tracks (second click)
      playerService.$on(
        `project-remove-track-completely-${this.projectId}`,
        (trackId) => {
          const idx = this.tracks.findIndex(
            (t) => Number(t.id) === Number(trackId),
          );
          if (idx !== -1) {
            this.tracks.splice(idx, 1);
            this.collectionTotal = Math.max(
              0,
              Number(this.collectionTotal || 0) - 1,
            );

            // Force re-render remaining tracks
            this.tracks.forEach((track) => (track.forceRender = true));
            this.dateRerenderer = Date.now();

            this.emitTrackListCollectionTotalUpdate(
              this.getQuicklistCollectionTotal(),
            );
          }
        },
      );
    }

    playerService.$on("collapse-sub-tracks", () => {
      this.collapseSubtracks();
    });

    playerService.$on("expand-sub-tracks", () => {
      this.expandSubtracks();
    });

    // Listen for forced loader hide when resource URL doesn't change (already empty)
    playerService.$on(
      "force-track-list-loader-hide-" + this.trackListEventId,
      () => {
        this.tracklistLoader = false;
      },
    );

    playerService.$on("loading-played-tracks", (trackIdLength) => {
      this.playedTracks = trackIdLength;
    });

    if (this.trackListEventId == window.searchTrackResultsTrackListEventId) {
      window.searchTrackResultsTrackListRef =
        this.$refs["virtualList" + this._uid];
    }
  },

  watch: {
    trackResourceUrl: function (newVal, oldVal) {
      // Reset scroll position to top when track resource changes
      // this.cachedScrollTopPosition = 0;

      // Clear our current tracks as we don't want to add any different tracks on the end.
      this.reset();

      // Set loading state after reset to prevent "No track results" flash
      // Only set loading if URL is not empty to avoid stuck loading state
      if (this.trackResourceUrl !== "") {
        this.tracklistLoader = true;
      }

      // Kickoff the loader to get the new tracks.
      this.currentLoadPromise = this.loadTrackResource();
    },

    searchFilters: function (value, old) {
      // Compare JSON strings to detect actual changes in filter values
      const newFiltersJson = JSON.stringify(value);

      if (this.lastSearchFiltersJson === newFiltersJson) {
        // Filters haven't actually changed, don't reload
        return;
      }

      // Store the new state
      this.lastSearchFiltersJson = newFiltersJson;

      // Clear our current tracks as we don't want to add any different tracks on the end.
      this.reset();

      // Set loading state after reset to prevent "No track results" flash
      this.tracklistLoader = true;

      // Kickoff the loader to get the new tracks.
      this.currentLoadPromise = this.loadTrackResource();
    },

    downloadAll: function (value) {
      this.handleDownloadAllBtnVisibility();
    },

    sortTime: function (value) {
      if (value == true) {
        this.unnestedTracks = true;
      } else {
        this.unnestedTracks = false;
      }
    },
  },

  computed: {
    isMobile() {
      return $("html").hasClass("is-mobile-os") || window.innerWidth < 768;
    },
  },

  components: {
    loading: LoadingComponent,
    "virtual-list": VirtualList,
    Intersect,
  },
});
</script>
